var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepUpSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240,410a70,70,0,0,0-70,70H310A70,70,0,0,0,240,410Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240,330A150,150,0,0,0,90,480h70a80,80,0,0,1,160,0h70A150,150,0,0,0,240,330Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240,170A309.35,309.35,0,0,0,0,283.79V480H80a160,160,0,0,1,320,0h80V283.79A309.35,309.35,0,0,0,240,170Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240,166A313.31,313.31,0,0,1,480,277.55V137.73a418.16,418.16,0,0,0-480,0V277.55A313.31,313.31,0,0,1,240,166Z",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepUpSquare);
export default __webpack_public_path__ + "static/media/StepUpSquare.0343bdcd085ce380595b3553f68329c7.svg";
export { ForwardRef as ReactComponent };